<div class="container mt-4">
  <div class="card mb-4 shadow-sm">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h4 class="mb-0">Rôles utilisateur</h4>

      <button class="btn btn-sm btn-outline-primary"
              (click)="toggleEditRoles()">
        {{ editRoles ? 'Terminer' : 'Modifier' }}
      </button>
    </div>

    <div class="card-body">

      <!-- Aucun rôle -->
      <div *ngIf="userRoles.length === 0" class="text-muted">
        Aucun rôle attribué
      </div>

      <!-- Liste rôles -->
      <div class="role-list">
        <span *ngFor="let role of userRoles"
              class="badge badge-info role-badge">

          {{ role }}

          <button *ngIf="editRoles"
                  class="btn btn-xs btn-danger ml-1"
                  (click)="removeRole(role)"
                  [disabled]="loadingRole === role"
                  title="Retirer ce rôle">

            <span *ngIf="loadingRole === role"
                  class="spinner-border spinner-border-sm"></span>

            <span *ngIf="loadingRole !== role">&times;</span>
          </button>
        </span>
      </div>

      <!-- Ajouter rôle -->
      <div *ngIf="editRoles" class="mt-3">
        <label class="mb-2">Ajouter un rôle :</label>

        <div class="add-role-container">
          <button *ngFor="let role of availableRoles"
                  class="btn btn-sm btn-outline-success"
                  (click)="addRole(role)"
                  [disabled]="loadingRole === role">

            <span *ngIf="loadingRole === role"
                  class="spinner-border spinner-border-sm"></span>

            <span *ngIf="loadingRole !== role">
              + {{ role }}
            </span>
          </button>
        </div>
      </div>

    </div>
  </div>
</div>
